import { render, staticRenderFns } from "./taskItem.vue?vue&type=template&id=74980710&scoped=true"
import script from "./taskItem.vue?vue&type=script&lang=js"
export * from "./taskItem.vue?vue&type=script&lang=js"
import style0 from "./taskItem.vue?vue&type=style&index=0&id=74980710&prod&lang=scss&scoped=true"
import style1 from "./taskItem.vue?vue&type=style&index=1&id=74980710&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74980710",
  null
  
)

export default component.exports